<template>
    <div>
        <!-- 왼쪽메뉴 -->
        <left-navigation 
            :contents="contents"
            :slides='slides | getTitleOnly'
        ></left-navigation>

        <!-- 헤더 -->
        <main-header 
            :contents="contents"
            :chapterNumber="chapterNumber"
        ></main-header>

        <!-- 바디 -->
        <main-body 
            :contents="contents"
        ></main-body>

        <!-- 바텀 -->
        <main-footer 
            :contents="contents"
        ></main-footer>
    </div>
</template>
<script>
import contentsData from '../../../contents'
export default {
    props: ['chapterNumber'],
    data(){
        return{
            contents : {
                slideNumber : null,
                title : null,
                lectureCode : null,
                chapterCount : null,//chapter total
                chapterId : null,//current chapter Id
                chapterTitle : null,//current chapter title
                currentSlide : null,
                currentSlideCount : null
            },
            slides : null,
        }
    },
    filters: {
        //pass only needed data to Left & Bottom
        getTitleOnly(originalArray){
            var temp = [];
            _.map(originalArray,(value) => {
                temp.push({'title' : value.title});
            });
            return temp;
        }
    },
    methods:{
        getSlideNumber(){//get Page Number from URL
            let tempUrl = document.URL;
            let tempIndex = tempUrl.indexOf('.htm');
            return parseInt(tempUrl.substring(tempIndex - 2, tempIndex),10); 
        },
        setContentsFromJSON(){
            // 1) set current page number
            this.contents.slideNumber = this.getSlideNumber();

            // 2) set course title & lecture code
            this.contents.title = contentsData.title;
            this.contents.lectureCode = contentsData.lectureCode;

            // 3) set course chapters count
            this.contents.chapterCount = contentsData.chapters.length;

            // 4) set current chapter then current title & current slide
            let chapter = contentsData.chapters[this.chapterNumber - 1];
            if(!chapter){
                swal('알림','챕터정보를 표시할 수 없습니다.','error');
                return;
            }
            this.contents.chapterTitle = chapter.title;
            this.contents.chapterId = parseInt(chapter.id);
            this.contents.currentSlide = chapter.slides[this.contents.slideNumber - 1];
            this.contents.currentSlideCount = chapter.slides.length;

            // 5) set slides total slides
            this.slides = chapter.slides;
        },
    },
    mounted(){
        this.setContentsFromJSON();
        document.title = this.contents.title
    }
}
</script>